import Component from "gia/Component";
import gsap from "gsap";
import { ScrollTrigger } from "../vendor/gsap-bonus-umd/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default class Module extends Component {
  constructor(element) {
    super(element);
    this.ref = {};
  }

  mount() {
    this.DOM = {};
    this.DOM.view = this.element;

    this.DOM.video = this.element.querySelector("video");
    this.DOM.controls = this.element.querySelector('[g-ref="controls"]');
    this.DOM.soundOn = this.element.querySelector('[g-ref="soundOn"]');
    this.DOM.soundOff = this.element.querySelector('[g-ref="soundOff"]');
    this.DOM.play = this.element.querySelector('[g-ref="play"]');
    this.DOM.pause = this.element.querySelector('[g-ref="pause"]');

    this.DOM.soundOff.classList.add("tw-hidden");
    this.DOM.pause.classList.add("tw-hidden");

    this.DOM.video.addEventListener("click", () => {
      this.DOM.video.paused ? this.playVideo() : this.pauseVideo();
    });

    this.DOM.soundOn.addEventListener("click", () => {
      this.muteVideo();
    });

    this.DOM.soundOff.addEventListener("click", () => {
      this.unmuteVideo();
    });

    this.DOM.play.addEventListener("click", () => {
      this.playVideo();
    });

    this.DOM.pause.addEventListener("click", () => {
      this.pauseVideo();
    });

    this.st = ScrollTrigger.create({
      trigger: this.DOM.view,
      start: "top center",
      end: "bottom center",
      onEnter: () => {
        this.playVideo();
      },
      onEnterBack: () => {
        this.playVideo();
      },
      onLeave: () => {
        this.pauseVideo();
      },
      onLeaveBack: () => {
        this.pauseVideo();
      },
    });

    // onEnter / onEnterBack do not run if the trigger is already in-range when this mounts
    // (e.g. in-view on load, or after layout). Align playback with the current scroll state.
    if (this.st.isActive) {
      this.playVideo();
    }

    this._onVideoMetadata = () => {
      this.st?.refresh();
    };
    this.DOM.video.addEventListener("loadedmetadata", this._onVideoMetadata);
  }

  playVideo() {
    const video = this.DOM.video;
    const showPlayingUi = () => {
      this.DOM.play.classList.add("tw-hidden");
      this.DOM.pause.classList.remove("tw-hidden");
    };

    // Programmatic play (scroll) is not a user gesture: unmuted autoplay is blocked in most browsers.
    video
      .play()
      .then(showPlayingUi)
      .catch(() => {
        if (!video.muted) {
          this.muteVideo();
        }
        return video.play().then(showPlayingUi);
      })
      .catch(() => {});
  }

  pauseVideo() {
    this.DOM.video.pause();
    this.DOM.play.classList.remove("tw-hidden");
    this.DOM.pause.classList.add("tw-hidden");
  }

  muteVideo() {
    this.DOM.video.muted = true;
    this.DOM.soundOn.classList.add("tw-hidden");
    this.DOM.soundOff.classList.remove("tw-hidden");
  }

  unmuteVideo() {
    this.DOM.video.muted = false;
    this.DOM.soundOn.classList.remove("tw-hidden");
    this.DOM.soundOff.classList.add("tw-hidden");
  }

  unmount() {
    if (this._onVideoMetadata) {
      this.DOM.video?.removeEventListener("loadedmetadata", this._onVideoMetadata);
    }
    this.st?.kill();
  }
}
